import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'
//
export const stateListApi = (params) => API.get(`${URL.STATE_LIST_URL}`, params)
